import "./TransformationGallery.module.css";
import UstMenu from "@/reusable_sections/Header";
import SmileGallery from "./sections/SmileGallery";
import ProductFinderCTA from "./sections/ProductFinderCTA";
import KlinikKonforuVeTeknoloji from "./sections/Klinik Konforu ve Teknoloji";
import CorporateFooter from "@/reusable_sections/Footer";
export default function TransformationGalleryPage() {
  return <div>
      <UstMenu />
      <KlinikKonforuVeTeknoloji />
      <SmileGallery />
      <ProductFinderCTA />
      <CorporateFooter />
    </div>;
}